import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../../api/api";
import { SwitchCandidatePaginatedResponseSchema } from "../../schema/SwitchReservationSchema";

const API_VERSION = "v4";

interface GetSwitchCandidatesProps {
    source_booking_room_id: string;
    page?: number;
    search?: string;
    filter?: {
        room_type_id?: string;
        [key: string]: any;
    };
}

const useGetSwitchCandidates = (params: GetSwitchCandidatesProps) => {
    return useQuery({
        queryKey: ['bookings', 'switch-candidates', params.source_booking_room_id, params.page, params.search, params.filter],
        queryFn: async () => {
            const response = await privateApi.get(`/${API_VERSION}/booking/switch-reservation-candidates`, {
                params: {
                    source_booking_room_id: params.source_booking_room_id,
                    page: params.page || 1,
                    search: params.search,
                    filter: params.filter,
                }
            });

            // Validation
            const validationResult = SwitchCandidatePaginatedResponseSchema.safeParse(response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                // Return dummy pagination if backend doesn't support it yet to prevent crash
                // But following backend requirement, we should throw error if invalid
                throw new Error("Invalid switch candidates data format");
            }

            return validationResult.data;
        },
        enabled: !!params.source_booking_room_id,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useGetSwitchCandidates;
